import { addDays } from "date-fns";
import { filter, map, take } from "rxjs";

import { useShoppingCar } from "../../../common/components/useShoppingCart";
import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { PaymentQuotedSearch } from "./PaymentQuotedSearch";
import { PaymentQuotedTable } from "./PaymentQuotedTable";

export const PaymentQuotedResource = () => {
  const params$ = useQueryParams$().pipe(
    filter(() => {
      return (
        window.location.pathname ===
        "/web/importaciones/facturacion/pagos/prefacturas"
      );
    }),
    map((params: any) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));

      return {
        ...params,
        volante_nums: volante_nums.filter((x) => x),
        from_date,
        to_date,
      };
    })
  );

  const shoppingCar = useShoppingCar();

  return (
    <>
      <PaymentQuotedSearch
        params$={params$.pipe(take(1))}
        clearShoppingCar={() => {
          shoppingCar.items.clear();
        }}
      />
      <PaymentQuotedTable
        params$={params$}
        shoppingCar={shoppingCar}
        clearShoppingCar={() => {
          shoppingCar.items.clear();
        }}
      />
    </>
  );
};
